export const PAYMENT_FILTER_OPTIONS = [
  'All payments',
  'Suarte Plus',
  'Support',
  'Channels',
  'Originals',
  'Limited Edition',
];

export const GALLERY_SUBSCRIPTION_PAYMENT_FILTER = 'G. Subscription';

export function getPaymentFilterOptions(isGallery) {
  if (!isGallery) {
    return PAYMENT_FILTER_OPTIONS;
  }

  return PAYMENT_FILTER_OPTIONS.map((option) => (
    option === 'Suarte Plus' ? GALLERY_SUBSCRIPTION_PAYMENT_FILTER : option
  ));
}

export function resolvePaymentCategory({
  type,
  description,
  productModel,
  isChannelSubscription = false,
}) {
  const normalizedType = String(type ?? '').trim().toLowerCase();
  const normalizedDescription = String(description ?? '').trim().toLowerCase();
  const normalizedProductModel = String(productModel ?? '').trim().toLowerCase();

  if (isChannelSubscription || ['channel', 'channel_subscription'].includes(normalizedType)) {
    return 'Channels';
  }
  if (normalizedType === 'support') {
    return 'Support';
  }
  if (['original', 'originals'].includes(normalizedType)) {
    return 'Originals';
  }
  if (['limited_edition', 'limited edition', 'limited-edition'].includes(normalizedType)) {
    return 'Limited Edition';
  }
  if (
    normalizedType === 'gallery_subscription'
    || normalizedProductModel === 'gallerysubscription'
  ) {
    return GALLERY_SUBSCRIPTION_PAYMENT_FILTER;
  }
  if (
    ['suarte_plus', 'subscriptions'].includes(normalizedType)
    || normalizedDescription.includes('suarte+')
    || normalizedDescription.includes('suarte plus')
  ) {
    return 'Suarte Plus';
  }

  return null;
}
